import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

/**
 * Helper class to manage subscriptions and prevent memory leaks
 * Extends this class in your components to automatically handle subscription cleanup
 */
@Injectable()
export abstract class SubscriptionManager implements OnDestroy {
  protected readonly destroy$ = new Subject<void>();
  private subscriptions = new Subscription();

  /**
   * Add a subscription to be automatically unsubscribed on component destroy
   */
  protected addSubscription(subscription: Subscription): void {
    this.subscriptions.add(subscription);
  }

  ngOnDestroy(): void {
    // Complete the destroy subject
    this.destroy$.next();
    this.destroy$.complete();
    
    // Unsubscribe from all subscriptions
    this.subscriptions.unsubscribe();
  }
}